<template>
  <div :key="key" class="dashboard-chart">
    <h4>Plazos de Cobro</h4>
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorPjeObjetivo"
      :separator-step="0"
      :min="indicadorPlazosMin"
      :max="indicadorPlazosMax"
      :gauge-color="indicadorPlazosColor"
      :scale-interval="10"/>
    <div class="dashboard-chart-text">
      <p>Plazo Objetivo: {{ indicadorPlazosObjetivo }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual }} días</p>
      <p v-if="indicadorPlazosObjetivo != 0">Pje Actual: {{ indicadorPjeObjetivo | numero(2, true) }} %</p>
      <p v-if="indicadorPlazosObjetivo == 0">Pje Actual: -- %</p>
      <!-- <p>Plazo Objetivo: {{ indicadorPlazosObjetivo | numero(2, true) }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual | numero(2, true) }} días</p> -->
      <p class="description">{{ indicadorPlazosDescripcion }}</p>
      <p v-if="verDatosPlazosClientes" 
        class="link" 
        @click.stop="exportarPlazosClientesComprobantes"><i class="fa fa-file-excel-o"></i>Exportar Datos</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorPlazosActual: 0,
      indicadorPlazosObjetivo: parseInt(0),
      indicadorPlazosMin: 0,
      indicadorPlazosMax: 100,
      indicadorPlazosColor:  [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      indicadorPlazosDescripcion: '',
      indicadorPjeObjetivo: 0,

      verDatosPlazosClientes: true
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosClientes')
        .then(() => {
          let indicador = this.$store.getters['resultadosAdministracion/indicadorPlazosClientes']

          this.indicadorPlazosActual = +(Math.round(indicador.plazoActual + "e+2")  + "e-2");
          this.indicadorPlazosObjetivo = parseFloat(indicador.plazoObjetivo);
          this.indicadorPlazosMax = indicador.plazoActual > 100 ? indicador.plazoActual : 100;
          this.indicadorPlazosDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          this.indicadorPjeObjetivo = parseFloat(indicador.pjeObjetivo);

          // /* Calculamos el pje alcanzado */
          // this.indicadorPjeObjetivo = parseFloat(indicador.plazoActual) / parseFloat(indicador.plazoObjetivo) * 100.00 ;

          // if (indicador.plazoObjetivo == 0) {
          //   this.indicadorPjeObjetivo = 100;
          // }

          // if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(110)) {
          //   this.indicadorPlazosColor = [{ offset: 0, color: this.rosa }, { offset: 100, color: this.rosa }];
          // } else 
          if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(100)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde }];
          } else if (parseFloat(this.indicadorPjeObjetivo) > parseFloat(50)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo }];
          }

          this.$emit('inicializado');
        })
        .finally(() => this.key++);
    },
    cancelar() {
      this.$store.dispatch('resultadosAdministracion/cancelarIndicadorPlazosClientes');
    },
    exportarPlazosClientesComprobantes() {
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getIndicadorPlazosClientesComprobantes')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosAdministracion/resultadosIndicadorPlazosClientesComprobantes'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSResumenPlazosClientes(rptComprobantes);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    }
  }
}
</script>

<style>
</style>


